<template>
  <JurnalList jenisJurnal="3" :title="title"  :routeInput="input" :routeEdit="edit" />
</template>

<script>
import JurnalList from '@/views/jurnal/JurnalList.vue';

export default {
    components: {
        JurnalList
    },
    data:() => ({
       title : 'Jurnal Penerimaan Kas',
       input : 'jpkinput',
       edit : 'jpkedit'
    }),
    methods: {
       
    }
}
</script>


<style>

</style>